import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=5a0d9860&"
import script from "./tiktok.vue?vue&type=script&lang=js&"
export * from "./tiktok.vue?vue&type=script&lang=js&"
import style0 from "./tiktok.vue?vue&type=style&index=0&id=5a0d9860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports